import { apiClient, type ApiClientResponse, routes } from 'common/services';

export const completeOnboardingTour = async () =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.onboardingSteps.complateAll);
